import { Component, Input, OnInit, Type, ViewChild, inject } from '@angular/core';
import { DynamicComponentService } from '@core/services/template/dynamic-component.service';
import { TemplateHostDirective } from '@shared/directives/template-host.directive';
import { IDynamicComponent } from '@core/services/template/dynamic.component';

@Component({
  selector: 'recrewt-section-content',
  templateUrl: './section-content.component.html',
  styleUrls: ['./section-content.component.scss'],
  standalone: false,
})
export class SectionContentComponent implements OnInit {
  private tplLoader = inject(DynamicComponentService);

  @Input() data = null;

  @Input() sectionType: Type<IDynamicComponent> | null = null;

  @ViewChild(TemplateHostDirective, { static: true })
  tplHost: TemplateHostDirective | undefined;

  ngOnInit(): void {
    if (!this.tplHost || !this.sectionType) {
      return;
    }
    this.tplLoader.loadComponent(this.tplHost.viewContainerRef, this.sectionType, this.data);
  }
}
